// @ts-nocheck
export const initYup = yup => {
  yup.addMethod(yup.string, 'isTajNumber', function (errorMessage) {
    return this.test(`test-taj-number`, errorMessage, function (tajNumber) {
      if (!tajNumber) {
        return true;
      }

      if (tajNumber.length !== 9) {
        return false;
      }

      // Convert TAJ number to array of digits
      const digits = tajNumber.split('').map(Number);

      // Calculate checksum
      const checksum =
        (digits[0] * 3 +
          digits[1] * 7 +
          digits[2] * 3 +
          digits[3] * 7 +
          digits[4] * 3 +
          digits[5] * 7 +
          digits[6] * 3 +
          digits[7] * 7) %
        10;

      // Check if checksum matches the last digit
      return checksum === digits[8];
    });
  });

  yup.addMethod(yup.string, 'isPhoneNumber', function (errorMessage) {
    return this.test(`test-phone-number`, errorMessage, function (phoneNumber) {
      if (!phoneNumber) {
        return true;
      }

      // regexp that validates phone numbers with country codes for example +36 or +421 etc.
      const regex = /^\+?[0-9]{8,}$/;

      return regex.test(phoneNumber) === true;
    });
  });
};
